import {Directive} from '@angular/core';
import {MatSelect} from '@angular/material/select';

@Directive({
	selector: '[matSelectResponsive]'
})
export class MatSelectResponsivePanelDirective {
	constructor(private host: MatSelect) {
		this.host.disableOptionCentering = true;
		this.host.panelClass = 'selector-up';
		this.host._onAttached = () => {
			setTimeout(() => {
				if (this.host.panel) {
					const panel: any = this.host.panel && this.host.panel.nativeElement;
					const parent: any = panel && panel.offsetParent;
					this.host.panelClass = parent && panel.offsetHeight <= parent.offsetTop ? 'selector-up' : '';
				}
			}, 0);
		};
	}
}
